import { place, poi, } from "@lonelyplanet/open-planet-node/dist/openPlanetTypes";
import { opTypeMapping } from "./opTypeMapping";
/**
 * Get the category label for a search result
 * @param result {ISearch} The search result
 */
var getResultCategory = function (result) {
    var opType = result.opType, poiSubtypes = result.poiSubtypes, parentName = result.parentName;
    if (opType === poi && poiSubtypes && parentName) {
        return parentName + " | " + poiSubtypes.join(",");
    }
    else if (opType === poi && poiSubtypes) {
        return poiSubtypes.join(",");
    }
    else if (opType === place && parentName) {
        return parentName;
    }
    else if (parentName) {
        return parentName + " | " + opTypeMapping[opType];
    }
    else {
        return opTypeMapping[opType] || "";
    }
};
export default getResultCategory;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/getResultCategory.ts
// module id = nYNN
// module chunks = 2